import React from 'react';

const Error = () => {
  return (
    <div className='container'>
      <div className='text-center'>
        <img
          src='../images/404.jpg'
          alt=""
          className='img-fluid'
          style={{ maxWidth: '500px' }}
        />
      </div>
    </div>
  );
};

export default Error;